/**
 * Couleurs de séries — plan de modernisation UX, §2.
 *
 * Un même indicateur garde la même couleur sur tous les écrans (vue
 * d'ensemble, analyses par motif, rapports) : l'utilisateur n'a pas à
 * réapprendre la légende. Ces couleurs sont distinctes des couleurs de
 * statut (succès, alerte, erreur), qui qualifient une valeur et non une série.
 */
export const SERIES_COLORS = {
  resolution_rate: "hsl(var(--chart-1))",
  conversion_rate: "hsl(var(--chart-1))",
  performance_rate: "hsl(var(--chart-2))",
  satisfaction_rate: "hsl(var(--chart-3))",
  reiteration_rate: "hsl(var(--chart-4))",
  procedure_rate: "hsl(var(--chart-5))",
  pain_points_rate: "hsl(var(--chart-5))",
  call_count: "hsl(var(--muted-foreground))",
} as const;

export type SeriesKey = keyof typeof SERIES_COLORS;

export const seriesColor = (key: string): string =>
  (SERIES_COLORS as Record<string, string>)[key] ?? "hsl(var(--primary))";
